import React, { memo } from 'react';
export var CheckMark = /*#__PURE__*/memo(function (_ref) {
  var _ref$alt = _ref.alt,
      alt = _ref$alt === void 0 ? 'checkmark' : _ref$alt,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#00788D' : _ref$fill,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '20px' : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '20px' : _ref$width;
  return /*#__PURE__*/React.createElement("svg", {
    alt: alt,
    height: height,
    width: width,
    viewBox: "0 0 20 20",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1---MBP-Catagory-Page---Best-Picks---Desktop-No-b.-Sure-Branding-3-Cards",
    transform: "translate(-361.000000, -4047.000000)",
    fill: fill
  }, /*#__PURE__*/React.createElement("g", {
    id: "Section-5---Our-Reviews-1---Vast",
    transform: "translate(360.000000, 3758.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Review-1---Vast",
    transform: "translate(0.000000, 0.614793)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Check-List",
    transform: "translate(1.000000, 288.385207)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Line1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ico_check_sm"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,-5.32907052e-14 C4.4800002,-5.32907052e-14 2.13162821e-14,4.48 2.13162821e-14,10 C2.13162821e-14,15.519997 4.4800002,20 10,20 C15.5200012,20 20,15.519997 20,10 C20,4.48 15.5200012,-5.32907052e-14 10,-5.32907052e-14 Z M8.0000002,14.999997 L3.0000002,10 L4.4100002,8.59 L8.0000002,12.169997 L15.5900012,4.58 L17.0000002,6 L8.0000002,14.999997 Z",
    id: "Fill-1"
  })))))))));
});